<div class="chat-dropdown">
  <button
    class="chat-btn"
    (click)="onDropdownToggle()"
    [class.has-unread]="unreadCount > 0"
  >
    <i class="fa fa-comments"></i>
    @if (unreadCount > 0) {
      <span class="badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    }
  </button>

  @if (isDropdownOpen) {
    <div class="chat-dropdown-menu">
      <div class="dropdown-header">
        <h6>{{ 'chatDropdown.messages' | translate }}</h6>
        @if (unreadCount > 0) {
          <span class="unread-label">{{ unreadCount }} {{ 'chatDropdown.unread' | translate }}</span>
        }
      </div>

      <div class="dropdown-body">
        @if (isLoading) {
          <div class="loading-state">
            <i class="fa fa-spinner fa-spin"></i>
            <span>{{ 'chatDropdown.loading' | translate }}</span>
          </div>
        } @else if (conversations.length === 0) {
          <div class="empty-state">
            <i class="fa fa-inbox"></i>
            <span>{{ 'chatDropdown.noConversations' | translate }}</span>
          </div>
        } @else {
          @for (conversation of conversations; track conversation.conversation_id) {
            <div
              class="conversation-item"
              [class.unread]="conversation.unread_count > 0"
              (click)="openConversation(conversation)"
            >
              <div class="conversation-icon" [ngClass]="'context-' + getConversationContext(conversation)">
                <i class="fa" [ngClass]="getContextIcon(conversation)"></i>
              </div>
              <div class="conversation-content">
                <div class="conversation-title">
                  {{ getConversationTitle(conversation) }}
                  @if (conversation.unread_count > 0) {
                    <span class="unread-dot"></span>
                  }
                </div>
                <div class="conversation-meta">
                  <span class="context-badge" [ngClass]="'context-' + getConversationContext(conversation)">
                    {{ getContextLabel(conversation) | translate }}
                  </span>
                  @if (getParticipantNames(conversation)) {
                    <span class="participant-names">
                      <i class="fa fa-users"></i>
                      {{ getParticipantNames(conversation) }}
                    </span>
                  }
                </div>
                <div class="conversation-preview">
                  {{ getLastMessagePreview(conversation) }}
                </div>
              </div>
              <div class="conversation-time">
                {{ getTimeAgo(conversation.updated_at) }}
              </div>
            </div>
          }
        }
      </div>

      <div class="dropdown-footer">
        <button class="view-all-btn" (click)="openAllChats()">
          {{ 'chatDropdown.viewAllMessages' | translate }}
        </button>
      </div>
    </div>
  }

  @if (isDropdownOpen) {
    <div class="dropdown-backdrop" (click)="isDropdownOpen = false"></div>
  }
</div>
